var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronUltralightWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronultralight",
    horizAdvX: 1085
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 376
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 811,
    d: "M51 1026v43h117v90q0 66 4 109q11 121 105 198.5t247 77.5q51 0 97 -10v-43q-99 13 -176.5 -0.5t-124.5 -48.5t-72.5 -80.5t-30.5 -99.5q-4 -45 -4 -103v-90h453v-1069h-45v1026h-408v-1026h-45v1026h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 774,
    d: "M51 1026v43h96v90q0 55 5 109q11 124 84.5 200t205.5 76q104 0 162 -39v-1259q0 -113 2 -142q3 -50 27 -64.5t88 -6.5v-39q-20 -4 -59 -4q-46 0 -72 23t-29 81q-2 41 -2 152v1231q-41 24 -115 24q-62 0 -109.5 -19.5t-75.5 -54t-43 -75.5t-19 -90q-4 -45 -4 -103v-90h219 v-43h-219v-1026h-46v1026h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 376
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 376
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 376
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 413,
    d: "M166 12q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM178 1413h58l-9 -1188h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 307,
    d: "M43 1505h45l-6 -499h-33zM190 1505h46l-7 -499h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M113 502v43h239l68 323h-246v43h256l107 502h43l-107 -502h227l107 502h43l-107 -502h230v-43h-240l-67 -323h245v-43h-256l-106 -502h-43l106 502h-227l-106 -502h-43l106 502h-229zM395 545h228l69 323h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M106 369h46q18 -162 123.5 -254.5t265.5 -100.5v668q-64 19 -114.5 40t-100.5 54.5t-83.5 74t-54 98t-20.5 126.5q0 159 106 258.5t267 108.5v155h45v-155q175 -6 274 -114t121 -275h-45q-20 159 -111 249.5t-239 96.5v-674q391 -114 391 -408q0 -141 -103.5 -240.5 t-287.5 -105.5v-155h-45v155q-112 5 -203.5 48.5t-155 133.5t-76.5 216zM217 1075q0 -60 17 -109.5t44.5 -84.5t71 -63.5t88 -47.5t103.5 -37v666q-86 -5 -158 -41.5t-119 -110t-47 -172.5zM586 14q161 4 251.5 87t90.5 212q0 135 -86 221.5t-256 139.5v-660z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1431,
    d: "M145 1116q0 142 71.5 234t191.5 92t191 -92t71 -234q0 -139 -71 -232t-191 -93t-191.5 93t-71.5 232zM195 1116q0 -127 55.5 -204.5t157.5 -77.5t157.5 77.5t55.5 204.5q0 128 -55.5 205.5t-157.5 77.5t-157.5 -77.5t-55.5 -205.5zM231 0l916 1413h53l-915 -1413h-54z M762 297q0 142 71 234t191 92t191 -92t71 -234q0 -139 -71 -232.5t-191 -93.5t-191 93.5t-71 232.5zM811 297q0 -127 55.5 -205t157.5 -78t157.5 78t55.5 205q0 128 -55.5 205.5t-157.5 77.5t-157.5 -77.5t-55.5 -205.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1310,
    d: "M143 324q0 163 109.5 261.5t288.5 119.5q-145 19 -232.5 104t-87.5 248q0 167 128 276t331 109q129 0 246 -21v-45q-121 23 -252 23q-175 0 -289.5 -92t-114.5 -248q0 -312 375 -330q41 -2 125 -2h225v311h45v-311h226v-43h-226v-682q-181 -31 -358 -31q-104 0 -183.5 10 t-148 34t-113 64t-69.5 101.5t-25 143.5zM193 324q0 -72 23.5 -126.5t64.5 -89t104 -56t135.5 -30t165.5 -8.5q181 0 309 25v645h-225q-84 0 -125 -4q-452 -38 -452 -356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 159,
    d: "M43 1505h45l-6 -499h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 600,
    d: "M248 717q0 241 64.5 478.5t172.5 401.5h45q-112 -184 -172.5 -410.5t-60.5 -469.5t61 -470t172 -411h-45q-108 164 -172.5 402t-64.5 479z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 600,
    d: "M70 -164q111 184 172 411t61 470t-60.5 469.5t-172.5 410.5h45q108 -164 172.5 -401.5t64.5 -478.5t-64.5 -479t-172.5 -402h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    d: "M184 645l15 45l325 -117l-6 398h49l-6 -398l326 117l14 -45l-328 -106l232 -306l-41 -28l-221 315l-221 -315l-41 28l231 306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M133 629v43h387v450h45v-450h387v-43h-387v-451h-45v451h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 307,
    d: "M-4 -238l94 287h47l2 -10l-104 -277h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 561,
    d: "M66 555v43h430v-43h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 307,
    d: "M82 12q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 538,
    d: "M-10 -61l514 1536h45l-514 -1536h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M74 707q0 166 26 297.5t81 231t146.5 153t215.5 53.5t215.5 -53.5t146.5 -153.5t81 -231t26 -297t-26 -298t-81 -231.5t-146.5 -153t-215.5 -53.5t-215.5 54t-146.5 153.5t-81 231t-26 297.5zM123 707q0 -152 22 -273.5t70 -218t131 -149t197 -52.5t197 52.5t131 148.5 t70 217.5t22 274.5q0 152 -22 273.5t-70 217.5t-131 148.5t-197 52.5q-92 0 -164 -35t-119.5 -96t-78.5 -149t-44.5 -189.5t-13.5 -222.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M281 1122v52l325 204q55 35 86 35h23v-1413h-45v1364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M82 0v33l489 475q206 201 280.5 315.5t74.5 233.5q0 150 -92 246t-254 96q-159 0 -266 -104t-124 -275l-2 -21h-45l2 21q20 191 140.5 306.5t294.5 115.5q128 0 219 -53t133.5 -138.5t42.5 -193.5q0 -88 -42.5 -178.5t-118.5 -181t-204 -212.5l-458 -442h833v-43h-903z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M92 418h45l2 -21q18 -172 122 -277.5t280 -105.5q180 0 294.5 96t114.5 265q0 148 -106.5 237.5t-319.5 89.5h-35v43h35q97 0 188 39t153.5 118.5t62.5 180.5q0 156 -95.5 236t-246.5 80q-160 0 -263 -95t-120 -262l-2 -20h-45l2 20q18 187 137 293.5t293 106.5 q185 0 287 -99.5t102 -255.5q0 -130 -86.5 -229t-218.5 -127q156 -24 241.5 -112.5t85.5 -243.5q0 -185 -129 -294.5t-329 -109.5q-188 0 -307 110t-140 316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M43 410v32l752 971h34v-960h203v-43h-203v-410h-45v410h-741zM102 453h682v890q-108 -150 -184 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M102 385h45l3 -20q15 -156 116 -253.5t262 -97.5q76 0 147 25.5t130.5 74.5t95 131t35.5 185q0 187 -105 299.5t-272 112.5q-271 0 -383 -238h-45l133 801h717v-43h-678l-119 -678l78 100q135 101 301 101q194 0 308 -128t114 -325q0 -141 -63.5 -247.5t-166.5 -160 t-229 -53.5q-75 0 -144 22.5t-128 68.5t-99.5 124t-50.5 179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M88 612q0 830 496 830q179 0 273 -92.5t130 -268.5l4 -20h-45l-4 20q-32 161 -120.5 239.5t-237.5 78.5q-73 0 -133.5 -18.5t-120.5 -70.5t-102 -136t-69 -224.5t-30 -326.5l41 104q67 102 169 156.5t224 54.5q107 0 193.5 -39.5t142 -107t85.5 -155.5t30 -187 q0 -132 -58.5 -240.5t-166.5 -173t-244 -64.5q-457 0 -457 641zM143 483q0 -132 46 -237t139 -168.5t219 -63.5q188 0 303 124.5t115 307.5q0 196 -112 322.5t-294 126.5q-173 0 -294.5 -118.5t-121.5 -293.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M92 1370v43h926v-22l-746 -1391h-53l737 1370h-864z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M80 358q0 141 84 240.5t233 136.5q-118 32 -182.5 122t-64.5 218q0 157 109 262t300 105q198 0 304 -104t106 -263q0 -129 -70.5 -220t-193.5 -120q148 -35 224.5 -133.5t76.5 -243.5q0 -92 -37.5 -166.5t-101.5 -122.5t-147 -74t-177 -26q-134 0 -237.5 44t-164.5 133 t-61 212zM129 358q0 -88 36.5 -156.5t97 -108.5t133 -60.5t151.5 -20.5q58 0 114.5 12t110 39.5t94 67t65.5 98t25 129.5q0 160 -105 257.5t-300 97.5q-197 0 -309.5 -98t-112.5 -257zM199 1075q0 -80 31 -143t83.5 -100.5t115 -56.5t130.5 -19t131 19t115 56.5t83.5 100.5 t31.5 143q0 149 -98 236.5t-263 87.5t-262.5 -87.5t-97.5 -236.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M72 965q0 132 58.5 240.5t166.5 172.5t244 64q456 0 456 -641q0 -416 -128 -623t-365 -207q-179 0 -274.5 92.5t-131.5 268.5l-4 20h45l4 -20q64 -318 361 -318q440 0 452 777l-41 -105q-67 -102 -169 -156.5t-224 -54.5q-107 0 -193.5 39.5t-142 107.5t-85 156 t-29.5 187zM121 967q0 -196 111.5 -322.5t293.5 -126.5q173 0 294.5 118.5t121.5 293.5q0 132 -45.5 237t-138.5 168.5t-219 63.5q-188 0 -303 -124.5t-115 -307.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 307,
    d: "M82 12q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM82 1065q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 307,
    d: "M-4 -238l94 287h47l2 -10l-104 -277h-39zM82 1065q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M145 522v41l822 400v-52l-760 -368l760 -369v-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M113 444v43h860v-43h-860zM113 813v43h860v-43h-860z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M119 123v51l760 369l-760 368v52l821 -400v-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1069,
    d: "M102 1012q8 191 126 310.5t302 119.5q185 0 288.5 -103t103.5 -262q0 -202 -191 -383q-137 -131 -177 -220.5t-40 -248.5h-41q1 120 16.5 189t62 139t146.5 168q90 89 132 174t42 182q0 150 -93 236t-249 86q-171 0 -271 -105t-112 -282h-45zM455 12q0 17 12 29t29 12 t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1742,
    d: "M125 500q0 157 48.5 296t131.5 240.5t190.5 175.5t227.5 111t240 37q298 0 483.5 -186t185.5 -482q0 -128 -31.5 -232.5t-84.5 -170t-120 -100.5t-141 -35q-87 0 -146.5 46.5t-59.5 153.5l-37 -78q-104 -139 -248 -139q-46 0 -87 14.5t-80 47t-62 96t-23 151.5 q0 144 56 268t156.5 199.5t221.5 75.5q104 0 154 -69l43 -107l33 139h51l-103 -428q-26 -113 -26 -180q0 -70 43.5 -108.5t118.5 -38.5q137 0 230 134.5t93 350.5q0 294 -174 464.5t-459 170.5q-89 0 -180.5 -25t-178 -72t-162.5 -118.5t-132.5 -159t-89.5 -200.5t-33 -236 q0 -161 53 -292t142 -213.5t202 -126.5t238 -44q164 0 289.5 38.5t271.5 139.5l25 -39q-162 -109 -290.5 -145.5t-295.5 -36.5q-103 0 -201 27.5t-186 85.5t-154 140.5t-104.5 201t-38.5 258.5zM561 455q0 -137 56 -206t155 -69q102 0 186.5 94t131.5 297l18 82 q28 122 -20 207.5t-150 85.5q-98 0 -184.5 -65t-139.5 -179t-53 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1202,
    d: "M197 0v1413h356q88 0 160 -4q162 -11 259 -99.5t97 -234.5q0 -133 -73 -221.5t-201 -108.5q161 -24 244 -122.5t83 -247.5q0 -162 -113.5 -262t-279.5 -109q-51 -4 -139 -4h-393zM242 43h381q65 0 92 2q69 5 130 25.5t113.5 58.5t83.5 101t31 143q0 51 -10.5 97 t-36.5 90.5t-65.5 77t-102 54.5t-141.5 25q-47 2 -107 2h-368v-676zM242 762h340q65 0 112 2q60 3 113.5 19.5t103.5 49.5t79.5 92.5t29.5 139.5t-28.5 140t-77.5 93.5t-105.5 50.5t-122.5 19q-47 2 -133 2h-311v-608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1386,
    d: "M104 702q0 216 84.5 385.5t230.5 262t326 92.5q221 0 356.5 -124.5t176.5 -326.5l4 -20h-45l-4 20q-37 182 -165 295t-331 113q-112 0 -215.5 -45.5t-186 -130.5t-132 -219.5t-49.5 -298.5q0 -171 45.5 -305t124.5 -217t180 -126t217 -43q111 0 201 33t152.5 92 t103 135.5t59.5 169.5l4 21h45l-4 -21q-20 -102 -63.5 -186t-111.5 -149t-167.5 -101.5t-222.5 -36.5q-131 0 -243.5 50t-194.5 142t-128.5 231t-46.5 308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1390,
    d: "M197 0v1413h407q99 0 150 -4q70 -5 142 -30t148 -79t135 -130t96.5 -195t37.5 -262q0 -142 -37 -261.5t-94 -196t-130 -132t-139.5 -82t-128.5 -33.5q-72 -8 -180 -8h-407zM242 43h362q106 0 174 8q69 8 136.5 38t131 85.5t112 130t77.5 180t29 228.5q0 107 -22 200.5 t-61 162t-89 122.5t-108.5 88.5t-116 54.5t-115.5 25q-45 4 -148 4h-362v-1327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1140,
    d: "M197 0v1413h858v-41h-813v-645h772v-41h-772v-645h833v-41h-878z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1087,
    d: "M197 0v1413h858v-41h-813v-645h751v-41h-751v-686h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1421,
    d: "M104 702q0 216 86.5 385.5t237.5 262t338 92.5q221 0 356 -124.5t176 -326.5l5 -20h-46l-4 20q-37 182 -165 295t-330 113q-118 0 -225 -45.5t-192.5 -130.5t-136 -219.5t-50.5 -298.5q0 -171 45.5 -305t125.5 -217t182 -126t220 -43q68 0 137.5 17.5t140.5 60t125 106 t88.5 164.5t34.5 226h-477v41h522v-629h-45v377l-41 -133q-83 -140 -212.5 -206.5t-276.5 -66.5q-133 0 -246.5 50t-196.5 142t-129.5 230.5t-46.5 308.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1341,
    d: "M197 0v1413h45v-698h909v698h45v-1413h-45v672h-909v-672h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 387,
    d: "M197 0v1413h45v-1413h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1013,
    d: "M96 459h45l2 -62q4 -103 32 -178.5t76.5 -119.5t108.5 -64.5t134 -20.5q149 0 235 88.5t100 249.5q5 56 5 164v897h45v-881q0 -104 -5 -186q-5 -73 -29.5 -138t-70 -119.5t-119 -86t-166.5 -31.5q-182 0 -283 106.5t-108 319.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1132,
    d: "M197 0v1413h45v-749l807 749h59l-739 -686l727 -727h-68l-694 698l-92 -86v-612h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1103,
    d: "M197 0v1413h45v-1372h833v-41h-878z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1626,
    d: "M197 0v1413h71l572 -1370l575 1370h66v-1413h-43v819q0 470 2 559q-125 -317 -228 -559l-346 -819h-57l-344 819q-133 319 -227 559q4 -178 4 -559v-819h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1304,
    d: "M197 0v1413h67l854 -1372q-4 190 -4 604v768h45v-1413h-69l-852 1372q4 -190 4 -604v-768h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1460,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -210 -78.5 -377t-225 -263t-335.5 -96t-335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294 q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1067,
    d: "M197 0v1413h313q120 0 203 -10q74 -10 134 -35.5t107.5 -69t74 -111.5t26.5 -155q0 -175 -94.5 -273t-247.5 -118q-83 -10 -203 -10h-268v-631h-45zM242 674h268q112 0 195 10q137 16 219 102t82 246q0 151 -81.5 231.5t-219.5 96.5q-82 10 -195 10h-268v-696z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1464,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -455 -338 -658q91 -3 155.5 -30.5t143.5 -90.5l-28 -34q-78 62 -143.5 86t-145.5 24q-52 0 -137 -18q-73 -15 -146 -15q-189 0 -335.5 96t-225 263t-78.5 377z M154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1169,
    d: "M197 0v1413h342q119 0 202 -10q166 -20 254 -107.5t88 -238.5q0 -135 -78.5 -227t-216.5 -117q96 -27 152 -113t70 -213q17 -146 38.5 -228.5t55.5 -158.5h-53q-1 3 -9 26.5t-9.5 28l-9 27t-10 31.5t-8.5 32t-9 37.5t-8.5 39t-9 46.5t-7.5 50.5t-8 58.5 q-15 132 -79 219.5t-184 93.5q-45 2 -129 2h-329v-692h-45zM242 735h329q88 0 154 4q143 10 226 96.5t83 219.5q0 266 -301 305q-83 10 -194 10h-297v-635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1146,
    d: "M80 369h45q20 -167 149 -261t308 -94q175 0 291 91.5t116 232.5q0 76 -22 130t-75 95.5t-124.5 71.5t-185.5 63q-120 34 -197 67t-134 78t-81.5 104t-24.5 140q0 101 60.5 183t160.5 127t216 45q188 0 299 -110t133 -279h-45q-27 161 -132.5 253.5t-256.5 92.5 q-69 0 -136.5 -20t-123.5 -57t-90.5 -97t-34.5 -133q0 -51 10 -90.5t33.5 -72t53.5 -57t79.5 -47.5t101.5 -41.5t129 -40.5q231 -66 333.5 -154t102.5 -247q0 -158 -130.5 -264.5t-327.5 -106.5q-198 0 -338.5 102t-161.5 296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1187,
    d: "M66 1372v41h1126v-41h-541v-1372h-45v1372h-540z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1228,
    d: "M184 477v936h45v-944q0 -52 7 -127q6 -69 32.5 -126.5t74 -103.5t123.5 -72t173 -26t173 26t123.5 72t74 103.5t32.5 126.5q7 75 7 127v944h45v-936q0 -27 -7 -137q-11 -168 -126.5 -268.5t-321.5 -100.5t-322 100.5t-127 268.5q-6 95 -6 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1193,
    d: "M53 1413h49l529 -1374l528 1374h49l-546 -1413h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1685,
    d: "M53 1413h47l340 -1368l404 1348h61l377 -1344l365 1364h45l-381 -1413h-58l-379 1343l-407 -1343h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1171,
    d: "M57 0l508 705l-473 708h51l451 -670l498 670h59l-528 -706l516 -707h-62l-481 674l-481 -674h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1116,
    d: "M47 1413h53l473 -788l469 788h56l-504 -835v-578h-45v578z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1099,
    d: "M74 0v35l909 1335h-852v43h905v-41l-905 -1329h918v-43h-975z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 636,
    d: "M270 -164v1761h314v-43h-269v-1675h269v-43h-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 538,
    d: "M-10 1475h45l514 -1536h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 636,
    d: "M53 -121h269v1675h-269v43h314v-1761h-314v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M168 440l352 822h55l349 -822h-52l-325 779l-330 -779h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 -121h820v-43h-820v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M152 1413h57l123 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-43 3 -86 3q-77 0 -153 -10q-117 -14 -216.5 -49.5t-160 -102t-60.5 -154.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1114,
    d: "M145 0v1505h45v-674l58 123q70 84 148.5 118t191.5 34q209 0 337 -155.5t128 -403.5q0 -139 -40 -250t-108 -181.5t-155.5 -107.5t-186.5 -37q-102 0 -174 33t-139 107l-60 135v-246h-45zM190 469q0 -126 34 -218.5t90.5 -142t118.5 -72t130 -22.5q194 0 317.5 147 t123.5 378q0 107 -28 201.5t-79.5 166.5t-132.5 114t-180 42q-66 0 -123 -15t-107.5 -50t-86.5 -88.5t-56.5 -135t-20.5 -184.5v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1058,
    d: "M61 539q0 254 143 410.5t351 156.5q173 0 290 -100t140 -263h-45q-27 150 -127.5 236t-261.5 86q-78 0 -154.5 -32.5t-141 -94t-104.5 -163t-40 -226.5q0 -132 36.5 -237t98.5 -169t138 -97.5t159 -33.5q144 0 251.5 82.5t137.5 227.5h45q-32 -162 -151.5 -256.5 t-286.5 -94.5q-99 0 -186 39t-152 110.5t-102.5 179.5t-37.5 239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1114,
    d: "M61 530q0 139 40 250t108 181.5t155.5 107.5t186.5 37q102 0 174 -32.5t139 -106.5l60 -136v674h45v-1505h-45v246l-58 -123q-70 -84 -148.5 -118t-191.5 -34q-209 0 -337 155.5t-128 403.5zM111 539q0 -144 47 -261.5t144 -190.5t228 -73q66 0 123 15t107.5 50 t86.5 88.5t56.5 135t20.5 184.5v121q0 126 -34 218.5t-90.5 142t-118.5 72t-130 22.5q-194 0 -317 -146.5t-123 -377.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1067,
    d: "M61 543q0 250 138 406.5t342 156.5q90 0 165.5 -30.5t127.5 -82t88.5 -121t53.5 -146.5t17 -159q0 -16 -2 -39h-882q3 -134 40.5 -236.5t98 -161t131.5 -87.5t149 -29q136 0 247.5 80t156.5 236h45q-48 -173 -171 -266t-282 -93q-95 0 -178 37t-147 107t-101 180.5 t-37 247.5zM109 571h839q-2 108 -28 194t-66.5 140.5t-94.5 91t-109 51.5t-113 15t-116.5 -18.5t-114 -58t-98.5 -96t-70 -139t-29 -180.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 471,
    d: "M51 1026v43h117v172q0 66 4 109q8 95 62.5 144.5t123.5 49.5q51 0 97 -10v-43q-44 11 -80 11q-56 0 -91 -26q-59 -44 -67 -133q-4 -45 -4 -102v-172h219v-43h-219v-1026h-45v1026h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1114,
    d: "M61 530q0 139 40 250t108 181.5t155.5 107.5t186.5 37q102 0 174 -32.5t139 -106.5l60 -136v254h45v-798q0 -254 -2 -324q-6 -187 -123.5 -300.5t-319.5 -113.5q-78 0 -144 17t-123 53t-94.5 101t-49.5 153l-4 31h45l4 -31q10 -75 44 -131t85 -88t111 -47t130 -15 q185 0 287 105.5t107 279.5q2 72 2 228v41l-58 -123q-70 -84 -148.5 -118t-191.5 -34q-209 0 -337 155.5t-128 403.5zM111 539q0 -144 47 -261.5t144 -190.5t228 -73q66 0 123 15t107.5 50t86.5 88.5t56.5 135t20.5 184.5v121q0 126 -34 218.5t-90.5 142t-118.5 72 t-130 22.5q-194 0 -317 -146.5t-123 -377.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    d: "M145 0v1516h45v-685l43 107q59 83 147.5 125.5t190.5 42.5q162 0 258 -86.5t113 -245.5q8 -73 8 -176v-598h-45v580q0 105 -8 178q-16 143 -97 224t-229 81q-75 0 -142.5 -26.5t-121.5 -77.5t-85.5 -133.5t-31.5 -186.5v-639h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 335,
    d: "M127 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM145 0v1077h45v-1077h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 319,
    d: "M-66 -383q33 -6 61 -6q49 0 81 18q49 28 53 119q2 29 2 80v1249h45v-1227q0 -69 -2 -106q-4 -86 -51.5 -130t-116.5 -44q-36 0 -72 8v39zM113 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 937,
    d: "M145 0v1505h45v-1011l635 583h68l-574 -522l576 -555h-68l-544 524l-93 -84v-440h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 354,
    d: "M139 246v1259h45v-1259q0 -113 2 -142q3 -50 27 -64q15 -9 48 -10q18 0 40 3v-39q-20 -4 -59 -4q-46 0 -72 23t-29 81q-2 41 -2 152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1656,
    d: "M145 0v1077h45v-229l50 117q109 141 284 141q130 0 210.5 -73t105.5 -208l65 140q109 141 285 141q143 0 224 -85.5t99 -246.5q9 -82 9 -176v-598h-45v580q0 96 -9 178q-16 144 -84.5 225.5t-195.5 81.5q-144 0 -238 -114t-94 -333v-618h-45v580q0 105 -8 178 q-16 144 -85 225.5t-196 81.5q-144 0 -238 -114t-94 -333v-618h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    d: "M145 0v1077h45v-246l43 107q59 83 147.5 125.5t190.5 42.5q162 0 258 -86.5t113 -245.5q8 -73 8 -176v-598h-45v580q0 105 -8 178q-16 143 -97 224t-229 81q-75 0 -142.5 -26.5t-121.5 -77.5t-85.5 -133.5t-31.5 -186.5v-639h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1134,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5t366.5 -156.5t139.5 -412.5q0 -255 -139.5 -410.5t-366.5 -155.5t-366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1114,
    d: "M145 -401v1495h45v-263l58 123q70 84 148.5 118t191.5 34q209 0 337 -155.5t128 -403.5q0 -139 -40 -250t-108 -181.5t-155.5 -107.5t-186.5 -37q-102 0 -174 33t-139 107l-60 135v-647h-45zM190 469q0 -126 34 -218.5t90.5 -142t118.5 -72t130 -22.5q194 0 317.5 147 t123.5 378q0 107 -28 201.5t-79.5 166.5t-132.5 114t-180 42q-66 0 -123 -15t-107.5 -50t-86.5 -88.5t-56.5 -135t-20.5 -184.5v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1116,
    d: "M61 530q0 139 40 250t108 181.5t155.5 107.5t186.5 37q102 0 174 -32.5t139 -106.5l62 -140v267h45v-1495h-45v651l-60 -127q-70 -84 -148.5 -118t-191.5 -34q-209 0 -337 155.5t-128 403.5zM111 539q0 -144 47 -261.5t144 -190.5t228 -73q66 0 123 15t107.5 50 t86.5 88.5t56.5 135t20.5 184.5l2 -22v156l-2 -13q0 126 -34 218.5t-90.5 142t-118.5 72t-130 22.5q-194 0 -317 -146.5t-123 -377.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 526,
    d: "M145 0v1077h45v-231l43 123q43 65 106.5 101t137.5 36q33 0 47 -2v-41q-16 1 -31 1q-134 0 -214 -103q-89 -115 -89 -371v-590h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 890,
    d: "M53 319h45q47 -305 359 -305q134 0 222.5 62.5t88.5 175.5q0 112 -74.5 169.5t-269.5 102.5q-55 13 -99 28t-86.5 39t-71 54t-46 73.5t-17.5 96.5q0 125 94.5 208t241.5 83q81 0 146.5 -25t109 -69.5t71 -101.5t38.5 -126h-45q-34 142 -112.5 210.5t-209.5 68.5 q-119 0 -202.5 -66t-83.5 -180q0 -106 74 -161.5t218 -88.5q194 -43 282.5 -113t88.5 -200q0 -128 -101 -205.5t-261 -77.5q-161 0 -271 86.5t-129 261.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 483,
    d: "M57 1032v37h129v221h45v-221h211v-37h-211v-770q0 -88 2 -117q6 -81 52 -107q28 -16 82 -16q35 0 82 7v-37q-41 -6 -103 -6q-144 0 -156 139q-4 49 -4 145v762h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1077,
    d: "M127 479v598h45v-579q0 -106 8 -179q16 -143 97 -224t229 -81q75 0 142.5 26.5t121.5 77.5t85.5 133.5t31.5 186.5v639h45v-1077h-45v246l-43 -107q-59 -83 -147.5 -125.5t-190.5 -42.5q-162 0 -258 86.5t-113 245.5q-8 73 -8 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 958,
    d: "M27 1077h51l407 -1038l406 1038h51l-426 -1077h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1466,
    d: "M27 1077h51l325 -1032l310 1028h63l309 -1022l316 1026h49l-340 -1077h-57l-308 1022l-307 -1022h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 854,
    d: "M6 0l383 541l-366 536h53l344 -504l352 504h55l-381 -536l381 -541h-57l-350 510l-359 -510h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 935,
    d: "M27 1077h51l395 -1040l395 1040h52l-416 -1077q-53 -139 -98 -226.5t-87.5 -131t-79 -58t-85.5 -14.5q-41 0 -72 8v41q36 -8 80 -8q67 0 127 62t125 221l35 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 909,
    d: "M27 0v37l772 981h-717v43h776v-41l-774 -981h780v-39h-837z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 606,
    d: "M160 694v45q44 4 77.5 22t52 45.5t27.5 59t9 66.5q0 69 -21 225q-22 153 -22 213q0 227 264 227h35v-43h-37q-103 0 -160 -41.5t-57 -140.5q0 -35 20 -194q23 -172 23 -246q0 -73 -35 -133t-117 -80q57 -14 92.5 -53t47.5 -79.5t12 -84.5q0 -74 -23 -246 q-20 -159 -20 -195q0 -99 57 -140.5t160 -41.5h37v-43h-35q-264 0 -264 227q0 60 22 213q21 156 21 226q0 75 -40 129.5t-126 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 512,
    d: "M233 -410v2048h46v-2048h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 606,
    d: "M25 -121h36q218 0 218 182q0 28 -21 195q-22 165 -22 246q0 73 34.5 133t116.5 80q-57 14 -92.5 53t-47 79t-11.5 85q0 81 22 246q21 166 21 194q0 182 -218 182h-36v43h34q265 0 265 -227q0 -53 -23 -213q-20 -149 -20 -225q0 -35 9 -66.5t27.5 -59t51.5 -45.5t77 -22 v-45q-58 -6 -96.5 -35.5t-53.5 -69t-15 -87.5q0 -77 20 -226q23 -160 23 -213q0 -227 -265 -227h-34v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M115 469q0 240 176 240q58 0 107 -18t159 -79q100 -56 147 -74t93 -18q133 0 133 197h43q0 -240 -178 -240q-58 0 -107 17.5t-158 78.5q-99 55 -147 74t-94 19q-131 0 -131 -197h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 413,
    d: "M166 1073q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM178 -328l8 1188h41l9 -1188h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    d: "M88 543q0 122 35.5 226t97.5 176t145 116t177 51v158h45v-156q170 -1 285.5 -101t138.5 -261h-45q-27 148 -124.5 233t-254.5 88v-1061q138 6 240 87.5t130 222.5h46q-31 -156 -144 -250.5t-272 -100.5v-155h-45v155q-197 9 -326 163.5t-129 408.5zM137 553 q0 -127 34 -229.5t91.5 -167.5t129 -102t151.5 -42v1059q-75 -7 -146 -43.5t-130 -98.5t-94.5 -160t-35.5 -216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M113 0v41q62 18 117 49t101.5 77t73.5 111t27 142q0 73 -25.5 142.5t-80.5 158.5h-195v43h168q-96 157 -96 309q0 162 109 265.5t272 103.5q183 0 277.5 -109t107.5 -293h-45q-11 173 -98.5 266t-245.5 93q-135 0 -231.5 -90.5t-96.5 -233.5q0 -77 24.5 -150t77.5 -161 h482v-43h-455q100 -153 100 -301q0 -123 -67.5 -220.5t-196.5 -156.5h754v-43h-858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M154 252l116 117q-88 101 -88 247q0 147 88 248l-116 117l32 33l117 -117q101 88 240 88q138 0 239 -88l117 117l33 -33l-117 -117q88 -101 88 -248q0 -146 -88 -247l117 -117l-33 -33l-117 117q-101 -88 -239 -88q-139 0 -240 88l-117 -117zM231 616q0 -139 88 -232 t224 -93q135 0 223 93t88 232t-88 232.5t-223 93.5t-223.5 -93.5t-88.5 -232.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M43 1413h61l439 -706l438 706h57l-450 -713h354v-43h-377v-161h377v-43h-377v-453h-45v453h-377v43h377v161h-377v43h353z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 512,
    d: "M233 -328v697h46v-697h-46zM233 717v696h46v-696h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    d: "M100 569q0 133 83 212t214 104q-194 84 -194 266q0 132 92.5 211.5t241.5 79.5q159 0 249.5 -86.5t118.5 -231.5h-45q-36 139 -115 207t-210 68q-119 0 -201 -63.5t-82 -178.5q0 -218 344 -280q198 -36 312 -121t114 -226q0 -135 -89 -215t-228 -102 q112 -47 162.5 -116.5t50.5 -172.5q0 -127 -103 -203.5t-264 -76.5q-326 0 -399 338h45q74 -295 358 -295q133 0 223 63t90 170q0 81 -32 134.5t-119.5 97t-243.5 77.5q-68 15 -130.5 42t-119 67.5t-90 100.5t-33.5 130zM150 575q0 -79 51.5 -143.5t126.5 -101.5t166 -56 q66 -11 127 -30q66 1 126.5 17.5t112 49t82.5 88t31 127.5q0 120 -100 192.5t-300 112.5q-22 4 -108 27q-47 -5 -89 -15.5t-84.5 -32.5t-73 -52.5t-49.5 -77.5t-19 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M184 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM348 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1716,
    d: "M115 727q0 209 98.5 383.5t269 275.5t375.5 101q153 0 291 -59.5t237.5 -161t157.5 -242.5t58 -297t-58 -297t-157.5 -242.5t-237.5 -161t-291 -59.5q-205 0 -375.5 101t-269 275.5t-98.5 383.5zM160 727q0 -195 92.5 -359t253.5 -259t352 -95t352 95t253.5 259t92.5 359 t-92.5 359.5t-253.5 260t-352 95.5t-352 -95.5t-253.5 -260t-92.5 -359.5zM498 727q0 194 105 311t261 117q134 0 225 -73t109 -210h-45q-23 113 -95.5 176.5t-193.5 63.5q-145 0 -233 -112.5t-88 -270.5q0 -163 88 -272t225 -109q243 0 295 238h45q-27 -138 -117.5 -209.5 t-228.5 -71.5q-147 0 -249.5 116t-102.5 306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1028,
    d: "M285 508l280 340h60l-281 -340l281 -340h-60zM530 508l281 340h59l-280 -340l280 -340h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M176 705v43h719v-318h-45v275h-674z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 561,
    d: "M66 555v43h430v-43h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1069,
    d: "M104 1137q0 188 121 308t310 120t309.5 -120t120.5 -308q0 -190 -120.5 -311t-309.5 -121t-310 121t-121 311zM152 1137q0 -171 107.5 -280t275.5 -109t275.5 109t107.5 280q0 169 -107 277t-276 108t-276 -108t-107 -277zM416 934v418h102q29 0 47 -2q115 -13 115 -121 q0 -40 -22 -67t-62 -38q44 -18 53 -80q10 -66 37 -110h-49q-22 45 -31 104q-5 32 -19 47t-46 15h-84v-166h-41zM457 1139h57q35 0 47 2q33 5 54.5 26t21.5 56q0 40 -21.5 61.5t-52.5 26.5q-12 2 -33 2h-73v-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M164 1270v43h287v-43h-287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 565,
    d: "M74 1235q0 91 59 149t150 58t150 -58t59 -149t-59 -149t-150 -58t-150 58t-59 149zM121 1235q0 -73 45 -118.5t117 -45.5t116.5 45.5t44.5 118.5t-44.5 118.5t-116.5 45.5t-117 -45.5t-45 -118.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M102 0v43h820v-43h-820zM102 629v43h387v430h46v-430h387v-43h-387v-430h-46v430h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M283 1188l123 225h57l-141 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1083,
    d: "M102 1034q0 153 85.5 260.5t236.5 116.5q35 2 115 2h399v-1638h-45v1595h-262v-1595h-45v880h-47q-80 0 -115 2q-151 9 -236.5 116.5t-85.5 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 278,
    d: "M94 625q0 20 12.5 32.5t32.5 12.5t32.5 -12.5t12.5 -32.5t-12.5 -32.5t-32.5 -12.5t-32.5 12.5t-12.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M139 -365q43 -22 109 -22q72 0 116 32t44 93q0 62 -49.5 93.5t-151.5 27.5l80 155h51l-64 -118q181 -16 181 -158q0 -83 -61.5 -125.5t-145.5 -42.5q-68 0 -109 20v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1028,
    d: "M158 168l280 340l-280 340h59l281 -340l-281 -340h-59zM403 168l281 340l-281 340h60l280 -340l-280 -340h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 966,
    d: "M147 -2q0 202 191 383q137 131 177 220.5t40 248.5h41q-1 -120 -16.5 -189t-62 -139t-146.5 -168q-90 -89 -132 -174t-42 -182q0 -150 93 -236t249 -86q171 0 271 105t112 282h45q-8 -191 -126 -310.5t-302 -119.5q-185 0 -288.5 103t-103.5 262zM532 1063q0 17 12 29 t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780zM502 1700h57l109 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780zM625 1507l108 193h58l-127 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780zM494 1507l133 193h47l133 -193h-49l-109 164l-108 -164h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780zM469 1567q0 84 74 84q33 0 116 -27q77 -25 97 -25q32 0 32 43h41q0 -83 -73 -83q-38 0 -117 26q-77 25 -96 25q-33 0 -33 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780zM537 1604q0 17 12 29t29 12t28.5 -12t11.5 -29t-11.5 -29t-28.5 -12t-29 12t-12 29zM680 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1261,
    d: "M74 0l547 1413h59l547 -1413h-49l-213 551h-633l-211 -551h-47zM348 594h598l-297 780zM520 1604q0 57 37.5 91t91.5 34t91.5 -34t37.5 -91t-37.5 -91t-91.5 -34t-91.5 34t-37.5 91zM569 1604q0 -35 21.5 -58.5t58.5 -23.5t58.5 23.5t21.5 58.5t-21.5 58.5t-58.5 23.5 t-58.5 -23.5t-21.5 -58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1837,
    d: "M-20 0l888 1413h883v-41h-817l29 -645h747v-41h-747l28 -645h781v-41h-824l-24 551h-547l-344 -551h-53zM406 594h518l-35 774z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1386,
    d: "M104 702q0 216 84.5 385.5t230.5 262t326 92.5q221 0 356.5 -124.5t176.5 -326.5l4 -20h-45l-4 20q-37 182 -165 295t-331 113q-112 0 -215.5 -45.5t-186 -130.5t-132 -219.5t-49.5 -298.5q0 -171 45.5 -305t124.5 -217t180 -126t217 -43q111 0 201 33t152.5 92 t103 135.5t59.5 169.5l4 21h45l-4 -21q-41 -206 -175.5 -335t-361.5 -138l-40 -75q180 -16 180 -158q0 -83 -61.5 -125.5t-145.5 -42.5q-68 0 -109 20v45q43 -22 109 -22q72 0 116 32t44 93q0 62 -49.5 93.5t-151.5 27.5l57 112q-127 5 -235 56.5t-187 143.5t-123.5 228.5 t-44.5 302.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1140,
    d: "M197 0v1413h858v-41h-813v-645h772v-41h-772v-645h833v-41h-878zM446 1700h58l108 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1140,
    d: "M197 0v1413h858v-41h-813v-645h772v-41h-772v-645h833v-41h-878zM569 1507l109 193h57l-127 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1140,
    d: "M197 0v1413h858v-41h-813v-645h772v-41h-772v-645h833v-41h-878zM438 1507l133 193h47l134 -193h-50l-108 164l-109 -164h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1140,
    d: "M197 0v1413h858v-41h-813v-645h772v-41h-772v-645h833v-41h-878zM481 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM625 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 387,
    d: "M72 1700h57l109 -193h-39zM197 0v1413h45v-1413h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 387,
    d: "M195 1507l108 193h57l-127 -193h-38zM197 0v1413h45v-1413h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 387,
    d: "M63 1507l134 193h47l133 -193h-49l-109 164l-108 -164h-48zM197 0v1413h45v-1413h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 387,
    d: "M106 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM197 0v1413h45v-1413h-45zM250 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1402,
    d: "M86 662v43h123v708h407q99 0 150 -4q70 -5 142 -30t148 -79t135 -130t96.5 -195t37.5 -262q0 -103 -19.5 -194.5t-52 -159.5t-76.5 -125t-92 -96t-100.5 -67t-98.5 -43t-89 -20q-72 -8 -181 -8h-407v662h-123zM254 43h362q107 0 175 8q57 7 113.5 29.5t111 59.5t101.5 93 t82.5 125.5t56 160.5t20.5 194q0 107 -22 200.5t-61 162t-89 122.5t-108.5 88.5t-116 54.5t-115.5 25q-45 4 -148 4h-362v-665h377v-43h-377v-619z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1304,
    d: "M197 0v1413h67l854 -1372q-4 190 -4 604v768h45v-1413h-69l-852 1372q4 -190 4 -604v-768h-45zM498 1567q0 84 73 84q35 0 117 -27q77 -25 96 -25q33 0 33 43h41q0 -83 -74 -83q-37 0 -116 26q-77 25 -97 25q-32 0 -32 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1460,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -210 -78.5 -377t-225 -263t-335.5 -96t-335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294 q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295zM596 1700h57l109 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1460,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -210 -78.5 -377t-225 -263t-335.5 -96t-335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294 q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295zM719 1507l108 193h58l-127 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1460,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -210 -78.5 -377t-225 -263t-335.5 -96t-335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294 q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295zM588 1507l133 193h47l133 -193h-49l-109 164l-108 -164h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1460,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -210 -78.5 -377t-225 -263t-335.5 -96t-335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294 q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295zM563 1567q0 84 74 84q35 0 117 -27q77 -25 96 -25q33 0 33 43h41q0 -83 -74 -83q-38 0 -117 26q-77 25 -96 25q-33 0 -33 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1460,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5t262 -55.5t202.5 -153t128.5 -233t46 -293.5q0 -210 -78.5 -377t-225 -263t-335.5 -96t-335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294t129 -219t187.5 -133t225 -47t225.5 47t187.5 133t129 219t48 294 q0 130 -31 242t-86 194t-129 140t-161.5 87t-182.5 29q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295zM631 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM774 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M203 332l309 309l-309 309l30 31l310 -309l309 309l31 -31l-310 -309l310 -309l-31 -31l-309 309l-310 -309z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1460,
    d: "M96 90l144 143q-136 198 -136 474q0 158 46 293.5t128.5 233t202.5 153t262 55.5q148 0 271 -58.5t209 -166.5l137 137l31 -31l-144 -143q135 -196 135 -473q0 -210 -78.5 -377t-225 -263t-335.5 -96q-148 0 -270 60t-207 168l-139 -140zM154 707q0 -261 118 -441 l916 916q-81 105 -197 161t-248 56q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295zM299 231q83 -105 198 -161t246 -56q119 0 225.5 47t187.5 133t129 219t48 294q0 258 -119 440z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1228,
    d: "M184 477v936h45v-944q0 -52 7 -127q6 -69 32.5 -126.5t74 -103.5t123.5 -72t173 -26t173 26t123.5 72t74 103.5t32.5 126.5q7 75 7 127v944h45v-936q0 -27 -7 -137q-11 -168 -126.5 -268.5t-321.5 -100.5t-322 100.5t-127 268.5q-6 95 -6 137zM492 1700h57l108 -193h-39z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1228,
    d: "M184 477v936h45v-944q0 -52 7 -127q6 -69 32.5 -126.5t74 -103.5t123.5 -72t173 -26t173 26t123.5 72t74 103.5t32.5 126.5q7 75 7 127v944h45v-936q0 -27 -7 -137q-11 -168 -126.5 -268.5t-321.5 -100.5t-322 100.5t-127 268.5q-6 95 -6 137zM614 1507l109 193h57 l-127 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1228,
    d: "M184 477v936h45v-944q0 -52 7 -127q6 -69 32.5 -126.5t74 -103.5t123.5 -72t173 -26t173 26t123.5 72t74 103.5t32.5 126.5q7 75 7 127v944h45v-936q0 -27 -7 -137q-11 -168 -126.5 -268.5t-321.5 -100.5t-322 100.5t-127 268.5q-6 95 -6 137zM483 1507l133 193h48 l133 -193h-49l-109 164l-109 -164h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1228,
    d: "M184 477v936h45v-944q0 -52 7 -127q6 -69 32.5 -126.5t74 -103.5t123.5 -72t173 -26t173 26t123.5 72t74 103.5t32.5 126.5q7 75 7 127v944h45v-936q0 -27 -7 -137q-11 -168 -126.5 -268.5t-321.5 -100.5t-322 100.5t-127 268.5q-6 95 -6 137zM526 1604q0 17 12 29t29 12 t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM670 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1116,
    d: "M47 1413h53l473 -788l469 788h56l-504 -835v-578h-45v578zM547 1507l108 193h58l-127 -193h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1310,
    d: "M197 0v1413h45v-242h268q120 0 203 -10q156 -21 249 -105t93 -245q0 -167 -94 -259t-248 -112q-82 -10 -203 -10h-268v-430h-45zM242 473h268q112 0 195 10q138 16 219.5 96t81.5 232q0 143 -81 217t-220 90q-82 10 -195 10h-268v-655z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1091,
    d: "M145 0v1004q0 38 5 131q10 191 125 300t288 109q153 0 259 -91.5t106 -246.5q0 -110 -68 -211q-95 -45 -138.5 -87t-43.5 -103q0 -57 26 -104t95 -107q104 -92 152 -167.5t48 -156.5q0 -132 -95 -205t-265 -73q-121 0 -221 20v47q109 -24 221 -24q143 0 227 60t84 169 q0 69 -37 130.5t-139 156.5q-88 81 -116.5 132.5t-28.5 121.5q0 75 48 124t157 107q45 71 45 168q0 138 -91.5 217.5t-230.5 79.5q-151 0 -250.5 -98t-111.5 -273q-5 -72 -5 -122v-1008h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-122 8 -239 -6.5t-216.5 -50t-160 -102t-60.5 -154.5zM336 1413h57l123 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-122 8 -239 -6.5t-216.5 -50t-160 -102t-60.5 -154.5zM498 1188l123 225h57l-141 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-122 8 -239 -6.5t-216.5 -50t-160 -102t-60.5 -154.5zM367 1188l133 225h47l133 -225h-49l-109 192l-108 -192h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-122 8 -239 -6.5t-216.5 -50t-160 -102t-60.5 -154.5zM342 1290q0 84 74 84q37 0 116 -26q77 -25 97 -25q33 0 33 43h40 q0 -84 -73 -84q-35 0 -117 27q-74 24 -96 24q-33 0 -33 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-122 8 -239 -6.5t-216.5 -50t-160 -102t-60.5 -154.5zM399 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12 t-12 29zM563 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1011,
    d: "M96 260q0 91 54.5 162t148 113.5t208.5 64t245 21.5h69v55q0 92 -4 139q-10 121 -87 184.5t-210 63.5q-81 0 -150 -27t-122.5 -92.5t-65.5 -161.5h-45q9 137 117 230.5t266 93.5q157 0 244 -74.5t98 -210.5q4 -55 4 -141v-332q0 -125 19 -348h-47l-15 264l-47 -108 q-56 -90 -147 -137.5t-201 -47.5q-157 0 -244.5 73.5t-87.5 215.5zM145 262q0 -116 72.5 -182t216.5 -66q112 0 202 59.5t137.5 153.5t47.5 201v147q-122 8 -239 -6.5t-216.5 -50t-160 -102t-60.5 -154.5zM395 1298q0 57 36.5 92t90.5 35t90.5 -35t36.5 -92t-36.5 -92 t-90.5 -35t-90.5 35t-36.5 92zM442 1298q0 -35 21.5 -59.5t58.5 -24.5t58.5 24.5t21.5 59.5t-21.5 59.5t-58.5 24.5t-58.5 -24.5t-21.5 -59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1888,
    d: "M96 260q0 73 41 129t108 90.5t162.5 56t193.5 29.5t212 8h70v50q0 220 -85 330t-268 110q-60 0 -116.5 -16t-107.5 -48.5t-86 -88.5t-44 -128h-45q9 136 123.5 230t275.5 94q168 0 267 -82t121 -244q43 155 167.5 240.5t278.5 85.5q116 0 205.5 -46t141.5 -124t78 -171.5 t26 -197.5q0 -5 -3 -39h-882q2 -109 25.5 -196.5t62.5 -146t92 -97.5t112.5 -56.5t127.5 -17.5q136 0 247 80t156 236h45q-48 -173 -170.5 -266t-281.5 -93q-71 0 -139 21t-129 62.5t-106 112t-63 161.5l-43 -131q-151 -226 -417 -226q-71 0 -133 17t-112 50.5t-79 90.5 t-29 131zM145 262q0 -113 84.5 -180.5t225.5 -67.5q187 0 307.5 127t120.5 328v59q-136 6 -258.5 -3.5t-234.5 -37t-178.5 -85t-66.5 -140.5zM930 571h835q-2 108 -26.5 194t-62.5 141t-90.5 91t-108 51t-117.5 15q-85 0 -159.5 -30t-135 -88.5t-96.5 -154.5t-39 -219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1058,
    d: "M61 539q0 254 143 410.5t351 156.5q173 0 290 -100t140 -263h-45q-27 150 -127.5 236t-261.5 86q-78 0 -154.5 -32.5t-141 -94t-104.5 -163t-40 -226.5q0 -124 32 -224.5t87.5 -164.5t124.5 -101t147 -45h51l-2 -2q142 3 246.5 85t134.5 225h45q-32 -162 -151.5 -256.5 t-286.5 -94.5h-9l-41 -75q181 -16 181 -158q0 -83 -61.5 -125.5t-145.5 -42.5q-68 0 -109 20v45q43 -22 109 -22q72 0 116 32t44 93q0 62 -49.5 93.5t-151.5 27.5l59 116q-184 21 -302 171.5t-118 392.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1067,
    d: "M61 543q0 250 138 406.5t342 156.5q90 0 165.5 -30.5t127.5 -82t88.5 -121t53.5 -146.5t17 -159q0 -16 -2 -39h-882q3 -134 40.5 -236.5t98 -161t131.5 -87.5t149 -29q136 0 247.5 80t156.5 236h45q-48 -173 -171 -266t-282 -93q-95 0 -178 37t-147 107t-101 180.5 t-37 247.5zM109 571h839q-2 108 -28 194t-66.5 140.5t-94.5 91t-109 51.5t-113 15t-116.5 -18.5t-114 -58t-98.5 -96t-70 -139t-29 -180.5zM377 1413h57l123 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1067,
    d: "M61 543q0 250 138 406.5t342 156.5q90 0 165.5 -30.5t127.5 -82t88.5 -121t53.5 -146.5t17 -159q0 -16 -2 -39h-882q3 -134 40.5 -236.5t98 -161t131.5 -87.5t149 -29q136 0 247.5 80t156.5 236h45q-48 -173 -171 -266t-282 -93q-95 0 -178 37t-147 107t-101 180.5 t-37 247.5zM109 571h839q-2 108 -28 194t-66.5 140.5t-94.5 91t-109 51.5t-113 15t-116.5 -18.5t-114 -58t-98.5 -96t-70 -139t-29 -180.5zM500 1188l123 225h57l-141 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1067,
    d: "M61 543q0 250 138 406.5t342 156.5q90 0 165.5 -30.5t127.5 -82t88.5 -121t53.5 -146.5t17 -159q0 -16 -2 -39h-882q3 -134 40.5 -236.5t98 -161t131.5 -87.5t149 -29q136 0 247.5 80t156.5 236h45q-48 -173 -171 -266t-282 -93q-95 0 -178 37t-147 107t-101 180.5 t-37 247.5zM109 571h839q-2 108 -28 194t-66.5 140.5t-94.5 91t-109 51.5t-113 15t-116.5 -18.5t-114 -58t-98.5 -96t-70 -139t-29 -180.5zM369 1188l133 225h47l133 -225h-49l-109 192l-108 -192h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1067,
    d: "M61 543q0 250 138 406.5t342 156.5q90 0 165.5 -30.5t127.5 -82t88.5 -121t53.5 -146.5t17 -159q0 -16 -2 -39h-882q3 -134 40.5 -236.5t98 -161t131.5 -87.5t149 -29q136 0 247.5 80t156.5 236h45q-48 -173 -171 -266t-282 -93q-95 0 -178 37t-147 107t-101 180.5 t-37 247.5zM109 571h839q-2 108 -28 194t-66.5 140.5t-94.5 91t-109 51.5t-113 15t-116.5 -18.5t-114 -58t-98.5 -96t-70 -139t-29 -180.5zM401 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM565 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29 t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 335,
    d: "M-18 1413h57l123 -225h-39zM145 0v1077h45v-1077h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 335,
    d: "M143 1188l123 225h58l-142 -225h-39zM145 0v1077h45v-1077h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 335,
    d: "M12 1188l133 225h48l133 -225h-50l-108 192l-109 -192h-47zM145 0v1077h45v-1077h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 335,
    d: "M45 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM145 0v1077h45v-1077h-45zM209 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1069,
    d: "M61 526q0 168 56 300.5t165.5 210t256.5 77.5q155 0 272 -92l100 -133q-29 304 -174 459l-342 -142l-16 41l323 133q-97 82 -223 105l29 41q146 -43 240 -127l153 63l17 -41l-136 -55q191 -213 191 -737q0 -169 -33 -295.5t-94.5 -205t-146 -117.5t-191.5 -40 q-207 -1 -327 155t-120 400zM111 528q0 -242 116 -378t287 -136q195 0 302.5 154.5t107.5 425.5v39q0 195 -106.5 316.5t-278.5 121.5q-182 0 -305 -143.5t-123 -399.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    d: "M145 0v1077h45v-246l43 107q59 83 147.5 125.5t190.5 42.5q162 0 258 -86.5t113 -245.5q8 -73 8 -176v-598h-45v580q0 105 -8 178q-16 143 -97 224t-229 81q-75 0 -142.5 -26.5t-121.5 -77.5t-85.5 -133.5t-31.5 -186.5v-639h-45zM356 1290q0 84 74 84q38 0 117 -26 q77 -25 96 -25q33 0 33 43h41q0 -84 -74 -84q-35 0 -117 27q-73 24 -96 24q-33 0 -33 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1134,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5t366.5 -156.5t139.5 -412.5q0 -255 -139.5 -410.5t-366.5 -155.5t-366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234zM420 1413h57l123 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1134,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5t366.5 -156.5t139.5 -412.5q0 -255 -139.5 -410.5t-366.5 -155.5t-366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234zM543 1188l123 225h57l-141 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1134,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5t366.5 -156.5t139.5 -412.5q0 -255 -139.5 -410.5t-366.5 -155.5t-366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234zM412 1188l133 225h47l133 -225h-49l-109 192l-108 -192h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1134,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5t366.5 -156.5t139.5 -412.5q0 -255 -139.5 -410.5t-366.5 -155.5t-366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234zM387 1290q0 84 74 84q38 0 117 -26q77 -25 96 -25q33 0 33 43h41q0 -84 -74 -84q-34 0 -117 27q-73 24 -96 24q-33 0 -33 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1134,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5t366.5 -156.5t139.5 -412.5q0 -255 -139.5 -410.5t-366.5 -155.5t-366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234zM444 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM608 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M133 629v43h819v-43h-819zM489 332q0 23 15.5 38t38.5 15t38 -15t15 -38t-15 -38t-38 -15t-38.5 15t-15.5 38zM489 967q0 23 15.5 38t38.5 15t38 -15t15 -38t-15 -38.5t-38 -15.5t-38.5 15.5t-15.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1216,
    d: "M53 14l150 150q-109 149 -109 373q0 256 139.5 412.5t366.5 156.5q234 0 377 -168l156 156l30 -31l-159 -160q102 -148 102 -366q0 -255 -139.5 -410.5t-366.5 -155.5q-229 0 -371 158l-145 -145zM143 537q0 -203 93 -340l708 708q-64 78 -154.5 118t-189.5 40 q-90 0 -170 -32t-145.5 -94.5t-103.5 -165.5t-38 -234zM264 164q63 -74 151 -112t185 -38q90 0 170 32t145.5 94t103.5 164.5t38 232.5q0 198 -86 331z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1077,
    d: "M127 479v598h45v-579q0 -106 8 -179q16 -143 97 -224t229 -81q75 0 142.5 26.5t121.5 77.5t85.5 133.5t31.5 186.5v639h45v-1077h-45v246l-43 -107q-59 -83 -147.5 -125.5t-190.5 -42.5q-162 0 -258 86.5t-113 245.5q-8 73 -8 176zM350 1413h58l122 -225h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1077,
    d: "M127 479v598h45v-579q0 -106 8 -179q16 -143 97 -224t229 -81q75 0 142.5 26.5t121.5 77.5t85.5 133.5t31.5 186.5v639h45v-1077h-45v246l-43 -107q-59 -83 -147.5 -125.5t-190.5 -42.5q-162 0 -258 86.5t-113 245.5q-8 73 -8 176zM504 1188l123 225h57l-141 -225h-39z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1077,
    d: "M127 479v598h45v-579q0 -106 8 -179q16 -143 97 -224t229 -81q75 0 142.5 26.5t121.5 77.5t85.5 133.5t31.5 186.5v639h45v-1077h-45v246l-43 -107q-59 -83 -147.5 -125.5t-190.5 -42.5q-162 0 -258 86.5t-113 245.5q-8 73 -8 176zM373 1188l133 225h47l133 -225h-49 l-109 192l-108 -192h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1077,
    d: "M127 479v598h45v-579q0 -106 8 -179q16 -143 97 -224t229 -81q75 0 142.5 26.5t121.5 77.5t85.5 133.5t31.5 186.5v639h45v-1077h-45v246l-43 -107q-59 -83 -147.5 -125.5t-190.5 -42.5q-162 0 -258 86.5t-113 245.5q-8 73 -8 176zM406 1296q0 17 11.5 29t28.5 12t29 -12 t12 -29t-12 -29t-29 -12t-28.5 12t-11.5 29zM569 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 935,
    d: "M27 1077h51l395 -1040l395 1040h52l-416 -1077q-53 -139 -98 -226.5t-87.5 -131t-79 -58t-85.5 -14.5q-41 0 -72 8v41q36 -8 80 -8q67 0 127 62t125 221l35 86zM446 1188l123 225h58l-142 -225h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1114,
    d: "M145 -401v1906h45v-674l58 123q70 84 148.5 118t191.5 34q209 0 337 -155.5t128 -403.5q0 -139 -40 -250t-108 -181.5t-155.5 -107.5t-186.5 -37q-102 0 -174 33t-139 107l-60 135v-647h-45zM190 469q0 -126 34 -218.5t90.5 -142t118.5 -72t130 -22.5q194 0 317.5 147 t123.5 378q0 107 -28 201.5t-79.5 166.5t-132.5 114t-180 42q-66 0 -123 -15t-107.5 -50t-86.5 -88.5t-56.5 -135t-20.5 -184.5v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 935,
    d: "M27 1077h51l395 -1040l395 1040h52l-416 -1077q-53 -139 -98 -226.5t-87.5 -131t-79 -58t-85.5 -14.5q-41 0 -72 8v41q36 -8 80 -8q67 0 127 62t125 221l35 86zM348 1296q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM512 1296q0 17 12 29t29 12 t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2277,
    d: "M104 707q0 158 46 293.5t128.5 233t202.5 153t262 55.5q177 0 295 -63.5t232 -219.5l63 -168v422h858v-41h-813v-645h772v-41h-772v-645h834v-41h-879v422l-63 -160q-100 -153 -227 -222t-300 -69q-189 0 -335.5 96t-225 263t-78.5 377zM154 707q0 -161 47.5 -294 t129 -219t187.5 -133t225 -47q126 0 234 46.5t187 133.5t124 219t45 294q0 163 -45 295t-124 218t-187 132.5t-234 46.5q-119 0 -225 -46.5t-187.5 -132t-129 -218.5t-47.5 -295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2029,
    d: "M61 537q0 256 139.5 412.5t366.5 156.5q181 0 310.5 -101.5t173.5 -283.5q39 181 165.5 283t288.5 102q90 0 165.5 -30.5t127.5 -82t88 -121t53 -146.5t17 -159q0 -16 -2 -39h-881q2 -108 27.5 -196t65.5 -146.5t94 -98t111.5 -56.5t119.5 -17q136 0 247 80t156 236h45 q-48 -173 -170.5 -266t-281.5 -93q-158 0 -280 98t-163 285q-44 -180 -171.5 -281.5t-305.5 -101.5q-227 0 -366.5 155.5t-139.5 410.5zM111 537q0 -130 38 -232.5t103 -164.5t145 -94t170 -32t170 32t145.5 94t103.5 164.5t38 232.5q0 131 -38 234t-103.5 165.5 t-145.5 94.5t-170 32t-170 -32t-145 -94.5t-103 -165.5t-38 -234zM1073 571h836q-2 108 -28 194t-66 140.5t-93.5 91t-108 51.5t-112.5 15q-60 0 -119 -18.5t-114 -58t-97.5 -96t-69 -139t-28.5 -180.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1116,
    d: "M47 1413h53l473 -788l469 788h56l-504 -835v-578h-45v578zM459 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM602 1604q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M152 1188l133 225h47l133 -225h-49l-109 192l-108 -192h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M127 1290q0 84 74 84q37 0 116 -26q77 -25 97 -25q32 0 32 43h41q0 -84 -73 -84q-34 0 -117 27q-73 24 -96 24q-33 0 -33 -43h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 864
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1729
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 864
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1729
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 576
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 432
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 288
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 288
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 216
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 345
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 96
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 561,
    d: "M66 555v43h430v-43h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 561,
    d: "M66 555v43h430v-43h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 561,
    d: "M66 555v43h430v-43h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M143 573v43h738v-43h-738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M143 573v43h1762v-43h-1762z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 233,
    d: "M29 1016l151 489h41l-143 -499h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 233,
    d: "M12 1006l144 499h47l2 -10l-152 -489h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 307,
    d: "M-4 -238l94 287h47l2 -10l-104 -277h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 417,
    d: "M29 1016l151 489h41l-143 -499h-47zM213 1016l152 489h41l-144 -499h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 417,
    d: "M12 1006l144 499h47l2 -10l-152 -489h-41zM197 1006l143 499h47l2 -10l-151 -489h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 450,
    d: "M-4 -238l94 287h47l2 -10l-104 -277h-39zM139 -238l94 287h48l2 -10l-105 -277h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 356,
    d: "M86 625q0 40 26 66t66 26t66 -26t26 -66t-26 -66.5t-66 -26.5t-66 26.5t-26 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 716,
    d: "M82 12q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM287 12q0 17 12 29t29 12t29 -12t12 -29t-12 -29t-29 -12t-29 12t-12 29zM492 12q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -29t-29 -12t-28.5 12t-11.5 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 345
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 782,
    d: "M285 508l280 340h60l-281 -340l281 -340h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 782,
    d: "M158 168l280 340l-280 340h59l281 -340l-281 -340h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 432
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M-8 573l20 43h127q-2 27 -2 84q0 37 4 99h-98l20 43h80q30 294 175 447t364 153q113 0 189.5 -28.5t144.5 -94.5l-31 -33q-64 62 -134 87.5t-173 25.5q-87 0 -165 -31t-146 -94.5t-114 -174t-60 -257.5h757l-22 -43h-740q-2 -29 -2 -90q0 -64 2 -93h678l-18 -43h-658 q24 -286 148 -422.5t346 -136.5q158 0 287 82v-49q-133 -76 -297 -76q-488 0 -533 602h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1058,
    d: "M49 1313v39h389v-39h-172v-379h-45v379h-172zM494 934v416h63l145 -377l146 377h59v-416h-41l4 379l-145 -375h-49l-144 373l3 -377h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1075,
    d: "M0 0v1075h1075v-1075h-1075z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Z",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 307
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 262
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "b,h,k,thorn",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 29
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronUltralightWebfont);
export default __webpack_public_path__ + "static/media/aileron-ultralight-webfont.4bbcd122c0692a4a908ab925e7c8c445.svg";
export { ForwardRef as ReactComponent };